import { supabase } from './supabaseClient';

export const getRelatorioQuantitativo = async (obraId: number) => {
    const { data, error } = await supabase.rpc('get_relatorio_quantitativo_por_fase', {
        p_obra_id: obraId
    });
    if (error) throw error;
    return data;
};
